import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getFaqsWebsiteAudit(tenant: Tenant): Faq[] {
	return [
		{
			question: "Proč bychom si měli nechat udělat audit webu?",
			answer:
				"Audit odhalí slabá místa stránek, která mohou negativně ovlivňovat návštěvnost, konverze nebo umístění webu ve vyhledávačích. Pomůžeme vám vyřešit nejen technické, ale i marketingově-obchodní problémy na webu.",
		},
		{
			question: "Je audit vhodný i pro malé weby a e-shopy?",
			answer: "Ano, audit je užitečný pro weby všech velikostí, od malých firemních stránek až po rozsáhlé e-shopy.",
		},
		{
			question: "Zvládnete optimalizovat web i v případě, že je postaven na šabloně (např. WordPress, Wix, Shoptet)?",
			answer: "Ano, optimalizaci provádíme pro různé platformy včetně WordPress, Shopify, Wix a dalších.",
		},
		{
			question: "Jak dlouho audit webu trvá?",
			answer:
				"Délka auditu závisí na rozsahu webu a dalších detailech. Analýzu menších stránek provedeme během několika dní, zatímco u větších a složitějších projektů může trvat i několik týdnů.",
		},
		{
			question: "Můžeme si objednat jen audit a následnou optimalizaci řešit sami?",
			answer:
				"Ano, je to možné. Rádi si ale řešení problémů s webem vezmeme na starost kompletně – od auditu až po optimalizaci.",
		},
		{
			question: "Jak měříte úspěšnost optimalizace webu?",
			answer:
				"Úspěšnost hodnotíme na základě zlepšení klíčových metrik – například pozice ve vyhledávačích, rychlosti načítání, míra konverzí, organická návštěvnosti nebo změna chování uživatelů na stránkách.",
		},
		{
			question: "Pomůžete mi také s úpravou obsahu na webu?",
			answer:
				"Ano, nabízíme i audit a optimalizaci obsahu, včetně vylepšení struktury a optimalizace pro vyhledávače (SEO).",
		},
	];
}
